export default {
  state: {
    usr: null
  },
  mutations: {
    changeName (state, name) {
      state.name = name
    },
    setAuthedActions (state, payload) {
      state.authedActions = payload.authedActions
    },
    setUsr (state, payload) {
      state.usr = payload.usr
    },
    setLastLoginTime (state, lastLoginTime) {
      state.lastLoginTime = lastLoginTime
    }
  },
  getters: {
    propCount (state) {
      let keys = Object.keys(state)
      if (keys) {
        return keys.length
      }
      return 0
    }
  },
  actions: {
    changeName ({state, commit}) {
      commit('changeName', 'tmp' + Math.random())
    },
    changeNameAsync ({state, commit}) {
      setTimeout(() => {
        commit('changeName', 'tmp' + Math.random())
      }, 2000)
    },
    setAuthedActions ({state, commit}, payload) {
      commit('setAuthedActions', payload)
    },
    setUsr ({state, commit}, payload) {
      commit('setUsr', payload)
    },
    setLastLoginTime ({state, commit}, lastLoginTime) {
      commit('setLastLoginTime', lastLoginTime)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js